'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _memoWithDisplayName = require('../utils/memoWithDisplayName');

var _memoWithDisplayName2 = _interopRequireDefault(_memoWithDisplayName);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _ThrowError = require('../utils/ThrowError');

var _UnsafeUrl = require('../utils/UnsafeUrl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SHAPE_CLASSES = {
  default: '',
  circle: 'img-circle private-image--circle',
  rounded: 'img-rounded private-image--rounded',
  thumbnail: 'img-thumbnail private-image--thumbnail'
};

var OBJECT_FIT_CLASSES = {
  fill: '',
  contain: 'private-image--object-fit-contain'
};

var UIImage = (0, _memoWithDisplayName2.default)('UIImage', (0, _react.forwardRef)(function (props, ref) {
  var bordered = props.bordered,
      className = props.className,
      objectFit = props.objectFit,
      onError = props.onError,
      onLoad = props.onLoad,
      responsive = props.responsive,
      shape = props.shape,
      src = props.src,
      style = props.style,
      rest = _objectWithoutProperties(props, ['bordered', 'className', 'objectFit', 'onError', 'onLoad', 'responsive', 'shape', 'src', 'style']);

  if ((0, _UnsafeUrl.isUnsafeUrl)(src)) {
    (0, _ThrowError.throwErrorAsync)(new Error('UIImage: Detected XSS attempt! src="' + src + '"'));
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loadFailed = _useState2[0],
      setLoadFailed = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      styleOverrides = _useState4[0],
      setStyleOverrides = _useState4[1];

  /** A ref to the <img> element */


  var imgRef = (0, _react.useRef)(null);
  var img = imgRef.current;

  var needsPolyfill = !('objectFit' in document.documentElement.style || objectFit !== 'contain');

  var polyfillObjectFit = function polyfillObjectFit() {
    // If style overrides already exist, do nothing
    if (styleOverrides && Object.keys(styleOverrides).length !== 0) return;

    // Compute the natural image ratio
    var naturalWidth = img.naturalWidth,
        naturalHeight = img.naturalHeight;

    if (!naturalWidth || !naturalHeight) return;
    var imgAspectRatio = naturalWidth / naturalHeight;

    var renderedWidth = img.clientWidth;
    var renderedHeight = img.clientHeight;

    var fittedHeight = renderedWidth / imgAspectRatio;
    var fittedWidth = renderedHeight * imgAspectRatio;
    if (renderedHeight > fittedHeight) {
      setStyleOverrides({ height: fittedHeight });
    } else if (renderedWidth > fittedWidth) {
      setStyleOverrides({ width: fittedWidth });
    }
  };

  /** Re-render without any style overrides, then recompute style overrides */
  var resetOverrides = function resetOverrides() {
    setStyleOverrides({});
  };

  (0, _react.useLayoutEffect)(function () {
    if (!needsPolyfill || !img) return undefined;
    polyfillObjectFit();
    addEventListener('resize', resetOverrides);
    return function () {
      removeEventListener('resize', resetOverrides);
    };
  });

  var handleImageError = function handleImageError(evt) {
    if (onError) onError(evt);
    setLoadFailed(true);
  };

  var handleImageLoad = function handleImageLoad(evt) {
    if (onLoad) onLoad(evt);
    imgRef.current = evt.target;
    setLoadFailed(false);
    if (needsPolyfill) resetOverrides();
  };

  /* eslint-disable jsx-a11y/alt-text */
  return _react2.default.createElement('img', _extends({}, rest, {
    className: (0, _classnames2.default)('private-image', SHAPE_CLASSES[shape], OBJECT_FIT_CLASSES[objectFit], className, {
      'img-responsive private-image--responsive': responsive,
      'image-load-failed': loadFailed,
      'private-image--bordered': bordered
    }),
    onError: handleImageError,
    onLoad: handleImageLoad,
    ref: ref,
    src: (0, _UnsafeUrl.isUnsafeUrl)(src) ? null : src,
    style: _extends({}, style, styleOverrides)
  }));
  /* eslint-enable jsx-a11y/alt-text */
}));

UIImage.propTypes = {
  alt: _propTypes2.default.string.isRequired,
  bordered: _propTypes2.default.bool.isRequired,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onError: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  objectFit: _propTypes2.default.oneOf(Object.keys(OBJECT_FIT_CLASSES)).isRequired,
  responsive: _propTypes2.default.bool.isRequired,
  shape: _propTypes2.default.oneOf(Object.keys(SHAPE_CLASSES)).isRequired,
  src: _validHref2.default.isRequired,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

UIImage.defaultProps = {
  alt: '',
  bordered: false,
  objectFit: 'fill',
  responsive: true,
  shape: 'default'
};

exports.default = UIImage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/image/UIImage.js
// module id = 121
// module chunks = 177